import FlexBox from '@/atomic-components/FlexBox';
import { DesignFeatures } from './modal';
import CrossIcon from '../../../../assets/pdp/crossIcon.svg';
import { Box, Drawer } from '@mui/material';
import { LencoTypography } from '@/atomic-components/LencoTypography';
import { BasicCarousel } from '@/atomic-components/carousels/wrappers/basic-carousel';
import { LencoImage } from '@/atomic-components/Image';
import { getStyle } from '@/utils/theme/fonts';
import { getColor } from '@/utils/theme/colors';
import LencoButton from '@/atomic-components/LencoButton';
import { useEffect } from 'react';
import { emitMoeEvent } from '@/utils/dataLayer';

type ProductDesignFeatureGalleryProps = {
	designFeatures: DesignFeatures;
	setOpenProductGallery: () => void;
	openProductGallery: boolean;
};

const ProductDesignFeatureGalleryComponent = (
	props: ProductDesignFeatureGalleryProps
) => {
	const { designFeatures } = props;

	useEffect(() => {
		if (props.openProductGallery) {
			emitMoeEvent('Info Bottomsheet Opened', {
				heading: `Design Feature ${designFeatures?.label}`,
			});
		}
	}, [props.openProductGallery]);

	return (
		<Drawer
			anchor='right'
			open={props.openProductGallery}
			onClose={props.setOpenProductGallery}
		>
			<FlexBox direction='column' sx={{ width: '35vw', padding: '40px' }}>
				<FlexBox
					sx={{
						cursor: 'pointer',
						justifyContent: 'end',
						paddingBottom: '24px',
					}}
				>
					<Box onClick={props?.setOpenProductGallery}>
						<CrossIcon />
					</Box>
				</FlexBox>

				{designFeatures?.images?.length > 1 ? (
					<BasicCarousel spaceBetween={20} slidesPerView={1} dots={true}>
						{designFeatures.images.map((image, index) => {
							return (
								<Box
									key={image.url}
									sx={{
										width: '100%',
										backgroundColor: '#D9D9D9',
									}}
								>
									<LencoImage url={image.url} aspectRatio={image.aspectRatio} />
								</Box>
							);
						})}
					</BasicCarousel>
				) : (
					<Box sx={{ width: '440px', backgroundColor: '#D9D9D9' }}>
						<LencoImage
							url={designFeatures?.images[0]?.url}
							aspectRatio={designFeatures?.images[0]?.aspectRatio}
						/>
					</Box>
				)}

				<LencoTypography
					sx={{
						...getStyle('H10_Medium'),
						color: getColor('Gray 0'),
						paddingTop: '40px',
					}}
				>
					{designFeatures?.label}
				</LencoTypography>

				<LencoTypography
					sx={{
						...getStyle('P_Regular'),
						color: getColor('Gray -2'),
						paddingTop: '18px',
					}}
				>
					{designFeatures?.summary}
				</LencoTypography>

				<LencoButton
					variant='contained'
					sx={{
						border: '1px solid #777777',
						backgroundColor: '#FFFFFF',
						borderRadius: '100px',
						marginTop: '42px',
						height: '48px',
						width: '200px',
						padding: '',
					}}
					onClick={props.setOpenProductGallery}
				>
					<LencoTypography
						sx={{ ...getStyle('Small_SemiBold'), color: '#777777' }}
					>
						UNDERSTOOD
					</LencoTypography>
				</LencoButton>
			</FlexBox>
		</Drawer>
	);
};

export default ProductDesignFeatureGalleryComponent;
